/* =====================================================================
   LEGAVIA ITALIA — comportamiento de las páginas de Italia. Solo se carga desde layout/it.liquid.

   - Bloque de compra: plan + selector de estado con búsqueda (combobox
     accesible) + checkout con la variante REAL leída de Shopify.
   - Galería del PDF con ampliación, botones fijos en móvil, barra de lectura.
   ===================================================================== */
(function () {
  'use strict';

  var norm = function (s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]/g, '');
  };

  /* ------------------------------------------------------------------
     Bloque de compra
     ------------------------------------------------------------------ */
  function initBuy(root) {
    var dataEl = root.querySelector('[data-mtit-buy-data]');
    var form = root.querySelector('[data-mtit-buy-form]');
    if (!dataEl || !form) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var combo = root.querySelector('[data-mtit-combo]');
    var input = root.querySelector('[data-mtit-combo-input]');
    var list = root.querySelector('[data-mtit-combo-list]');
    var toggle = root.querySelector('[data-mtit-combo-toggle]');
    var empty = root.querySelector('[data-mtit-combo-empty]');
    var err = root.querySelector('[data-mtit-error]');
    var status = root.querySelector('[data-mtit-status]');
    var submit = root.querySelector('[data-mtit-submit]');
    var submitLabel = root.querySelector('[data-mtit-submit-label]');
    var variantInput = form.querySelector('[data-mtit-variant]');
    var sumPlan = root.querySelector('[data-mtit-sum-plan]');
    var sumState = root.querySelector('[data-mtit-sum-state]');
    var sumPrice = root.querySelector('[data-mtit-sum-price]');
    var sumFile = root.querySelector('[data-mtit-sum-file]');
    var planInputs = Array.prototype.slice.call(root.querySelectorAll('[data-mtit-plan-input]'));
    var planPriceEls = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-mtit-plan-price]'), function (el) {
      planPriceEls[el.getAttribute('data-mtit-plan-price')] = { el: el, initial: el.textContent.trim() };
    });

    var states = (data.states || []).map(function (row) {
      var keys = [norm(row[1]), norm(row[0])];
      if (row[2]) keys.push(norm(row[2]));
      return {
        abbr: row[0],
        name: row[1],
        alias: row[2] || '',
        keys: keys,
        words: row[1].split(/[\s,.]+/).map(norm).filter(Boolean),
      };
    });

    // Índice de variantes REALES por plan: valor de la opción normalizado -> variante
    var index = {};
    Object.keys(data.plans || {}).forEach(function (plan) {
      index[plan] = {};
      (data.plans[plan].variants || []).forEach(function (v) {
        index[plan][norm(v.o)] = v;
      });
    });

    function findVariant(plan, st) {
      if (!st || !index[plan]) return null;
      for (var i = 0; i < st.keys.length; i++) {
        if (index[plan][st.keys[i]]) return index[plan][st.keys[i]];
      }
      return null;
    }

    function firstVariant(plan) {
      var vs = (data.plans[plan] && data.plans[plan].variants) || [];
      return vs.length ? vs[0] : null;
    }

    var selected = null;
    var filtered = states.slice();
    var active = -1;
    var listId = list.id;

    function currentPlan() {
      for (var i = 0; i < planInputs.length; i++) if (planInputs[i].checked) return planInputs[i].value;
      return planInputs.length ? planInputs[0].value : 'complete';
    }

    /* ---- listbox ---- */
    function highlight(li, name, q) {
      var nameSpan = document.createElement('span');
      if (!q) {
        nameSpan.textContent = name;
      } else {
        var lower = name.toLowerCase();
        var raw = input.value.trim().toLowerCase();
        var pos = raw ? lower.indexOf(raw) : -1;
        if (pos > -1) {
          nameSpan.appendChild(document.createTextNode(name.slice(0, pos)));
          var m = document.createElement('mark');
          m.textContent = name.slice(pos, pos + raw.length);
          nameSpan.appendChild(m);
          nameSpan.appendChild(document.createTextNode(name.slice(pos + raw.length)));
        } else {
          nameSpan.textContent = name;
        }
      }
      li.appendChild(nameSpan);
    }

    function renderList(q) {
      list.innerHTML = '';
      filtered.forEach(function (st, i) {
        var li = document.createElement('li');
        li.id = listId + '-o' + i;
        li.className = 'mtit-combo__opt' + (i === active ? ' is-active' : '');
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', selected === st ? 'true' : 'false');
        li.dataset.index = String(i);
        highlight(li, st.name, q);
        var small = document.createElement('small');
        small.textContent = st.abbr;
        small.setAttribute('aria-hidden', 'true');
        li.appendChild(small);
        list.appendChild(li);
      });
      empty.hidden = filtered.length > 0;
      if (active > -1) {
        input.setAttribute('aria-activedescendant', listId + '-o' + active);
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function filter(query) {
      var q = norm(query);
      if (!q) {
        filtered = states.slice();
      } else {
        var scored = [];
        states.forEach(function (st, order) {
          var score = -1;
          if (norm(st.abbr) === q) score = 0;
          else if (st.keys[0].indexOf(q) === 0) score = 1;
          else if (st.alias && norm(st.alias).indexOf(q) === 0) score = 2;
          else if (st.words.some(function (w) { return w.indexOf(q) === 0; })) score = 3;
          else if (st.keys[0].indexOf(q) > -1 || (st.alias && norm(st.alias).indexOf(q) > -1)) score = 4;
          if (score > -1) scored.push({ st: st, score: score, order: order });
        });
        scored.sort(function (a, b) { return a.score - b.score || a.order - b.order; });
        filtered = scored.map(function (x) { return x.st; });
      }
      active = filtered.length ? 0 : -1;
      if (!q && selected) active = filtered.indexOf(selected);
      renderList(q);
    }

    function isOpen() { return !list.hidden; }

    function open() {
      if (isOpen()) return;
      list.hidden = false;
      combo.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
      scrollActive();
    }

    function close() {
      list.hidden = true;
      empty.hidden = true;
      combo.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function scrollActive() {
      if (active < 0) return;
      var el = document.getElementById(listId + '-o' + active);
      if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    function setActive(i) {
      if (!filtered.length) return;
      active = (i + filtered.length) % filtered.length;
      Array.prototype.forEach.call(list.children, function (li, idx) {
        li.classList.toggle('is-active', idx === active);
      });
      input.setAttribute('aria-activedescendant', listId + '-o' + active);
      scrollActive();
    }

    function choose(st) {
      selected = st;
      input.value = st.name;
      input.classList.add('is-selected');
      input.setAttribute('aria-invalid', 'false');
      clearError();
      close();
      update();
    }

    function clearError() {
      err.hidden = true;
      err.textContent = '';
      input.removeAttribute('aria-invalid');
    }

    function showError(msg) {
      err.textContent = msg;
      err.hidden = false;
      input.setAttribute('aria-invalid', 'true');
    }

    /* ---- summary ---- */
    function update() {
      var plan = currentPlan();
      var planName = (data.plans[plan] && data.plans[plan].name) || plan;
      sumPlan.textContent = planName;

      if (selected) {
        sumState.textContent = selected.name;
        sumState.classList.remove('is-empty');
      } else {
        sumState.textContent = data.text.none;
        sumState.classList.add('is-empty');
      }

      var v = findVariant(plan, selected);
      var fv = firstVariant(plan);
      if (v) sumPrice.textContent = v.p;
      else if (fv && planPriceEls[plan]) sumPrice.textContent = planPriceEls[plan].initial;
      else sumPrice.textContent = data.text.placeholder;

      Object.keys(planPriceEls).forEach(function (key) {
        var pv = findVariant(key, selected);
        planPriceEls[key].el.textContent = pv ? pv.p : planPriceEls[key].initial;
      });

      if (selected) {
        sumFile.textContent = (data.text.file || '').replace('[plan]', planName).replace('[state]', selected.name);
        sumFile.hidden = false;
      } else {
        sumFile.hidden = true;
      }

      variantInput.value = v ? String(v.id) : '';
      if (!data.ready) submit.setAttribute('aria-disabled', 'true');
      status.textContent = '';
    }

    /* ---- events ---- */
    input.addEventListener('click', function () {
      if (!isOpen()) {
        filter(selected && input.value === selected.name ? '' : input.value);
        open();
      }
    });

    input.addEventListener('input', function () {
      if (selected && input.value !== selected.name) {
        selected = null;
        input.classList.remove('is-selected');
        update();
      }
      clearError();
      filter(input.value);
      open();
    });

    input.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (!isOpen()) { filter(selected ? '' : input.value); open(); }
          else setActive(active + 1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (!isOpen()) { filter(selected ? '' : input.value); open(); }
          else setActive(active - 1);
          break;
        case 'Home':
          if (isOpen()) { e.preventDefault(); setActive(0); }
          break;
        case 'End':
          if (isOpen()) { e.preventDefault(); setActive(filtered.length - 1); }
          break;
        case 'Enter':
          if (isOpen()) {
            e.preventDefault();
            if (active > -1 && filtered[active]) choose(filtered[active]);
          }
          break;
        case 'Escape':
          if (isOpen()) {
            e.preventDefault();
            close();
            if (selected) input.value = selected.name;
          } else if (input.value && !selected) {
            input.value = '';
          }
          break;
        case 'Tab':
          if (isOpen() && input.value.trim() && active > -1 && filtered[active] && !selected) choose(filtered[active]);
          else close();
          break;
      }
    });

    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('[role="option"]');
      if (!li) return;
      var st = filtered[Number(li.dataset.index)];
      if (st) choose(st);
    });

    toggle.addEventListener('mousedown', function (e) { e.preventDefault(); });
    toggle.addEventListener('click', function () {
      if (isOpen()) { close(); return; }
      filter('');
      open();
      input.focus();
    });

    combo.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (combo.contains(document.activeElement)) return;
        close();
        if (!selected) {
          var q = norm(input.value);
          if (q) {
            var exact = states.filter(function (st) { return st.keys.indexOf(q) > -1; })[0];
            if (exact) choose(exact);
          }
        } else if (input.value !== selected.name) {
          input.value = selected.name;
        }
      }, 120);
    });

    planInputs.forEach(function (r) { r.addEventListener('change', update); });

    root.addEventListener('mtit:plan', function (e) {
      var plan = e.detail;
      planInputs.forEach(function (r) { r.checked = r.value === plan; });
      update();
    });

    /* ---- checkout ---- */
    function setLoading(on) {
      submit.classList.toggle('is-loading', on);
      submit.setAttribute('aria-busy', on ? 'true' : 'false');
      submitLabel.textContent = on ? data.text.loading : data.text.button;
      submit.disabled = on;
    }

    window.addEventListener('pageshow', function (e) { if (e.persisted) setLoading(false); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      status.textContent = '';
      if (!selected) {
        showError(data.text.errState);
        input.focus();
        return;
      }
      if (!data.ready) {
        status.textContent = data.text.notReady;
        return;
      }
      var v = findVariant(currentPlan(), selected);
      if (!v || !v.a) {
        status.textContent = data.text.errUnavailable;
        return;
      }
      variantInput.value = String(v.id);
      setLoading(true);

      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var clear = data.replaceCart
        ? fetch(data.routes.clear + '.js', { method: 'POST', headers: headers, credentials: 'same-origin' })
        : Promise.resolve();

      clear
        .then(function () {
          return fetch(data.routes.add + '.js', {
            method: 'POST',
            headers: headers,
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('add');
          window.location.assign(data.routes.checkout);
        })
        .catch(function (error) {
          if (error && error.name === 'TypeError') {
            // Red/fetch no disponible: envío normal del formulario (añade y va al checkout).
            HTMLFormElement.prototype.submit.call(form);
            return;
          }
          setLoading(false);
          status.textContent = data.text.errGeneric;
        });
    });

    update();
  }

  /* ------------------------------------------------------------------
     Botones "Choose Essential / Complete" fuera del bloque de compra
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mtit-plan]');
    if (!t) return;
    var buy = document.querySelector('[data-mtit-buy]');
    if (!buy) return;
    buy.dispatchEvent(new CustomEvent('mtit:plan', { detail: t.getAttribute('data-mtit-plan') }));
  });

  /* ------------------------------------------------------------------
     Selector de país: abrir desde enlaces "Change", cerrar al salir
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mtit-open-region]');
    if (opener) {
      var d = document.getElementById('mtit-region-header') || document.getElementById('mtit-region-footer');
      if (d) {
        e.preventDefault();
        d.open = true;
        d.scrollIntoView({ block: 'nearest' });
        var sum = d.querySelector('summary');
        if (sum) sum.focus();
      }
      return;
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-mtit-region][open]'), function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-mtit-region][open]'), function (d) {
      d.open = false;
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });

  /* ------------------------------------------------------------------
     Galería del PDF con ampliación
     ------------------------------------------------------------------ */
  function initGallery(root) {
    var dialog = root.querySelector('.mtit-lightbox');
    if (!dialog) return;
    var img = dialog.querySelector('.mtit-lightbox__img');
    var cap = dialog.querySelector('.mtit-lightbox__cap');
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mtit-zoom]');
      if (btn) {
        var src = btn.getAttribute('data-mtit-zoom');
        var caption = btn.getAttribute('data-mtit-caption') || '';
        if (typeof dialog.showModal !== 'function') { window.open(src, '_blank', 'noopener'); return; }
        img.src = src;
        img.alt = caption;
        cap.textContent = caption;
        dialog.showModal();
        return;
      }
      if (e.target.closest('[data-mtit-close]') || e.target === dialog) dialog.close();
    });
    root.addEventListener('contextmenu', function (e) {
      if (e.target.tagName === 'IMG') e.preventDefault();
    });
  }

  /* ------------------------------------------------------------------
     Botón fijo en móvil (landing): visible tras el hero, oculto cuando
     el bloque de compra o el pie están en pantalla.
     ------------------------------------------------------------------ */
  function initSticky(bar) {
    var section = bar.closest('[data-mtit-buy]');
    var footer = document.querySelector('.mtit-footer');
    var hidden = { buy: false, footer: false };
    bar.hidden = false;
    function refresh() {
      var show = window.scrollY > 520 && !hidden.buy && !hidden.footer;
      bar.classList.toggle('is-visible', show);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === section) hidden.buy = en.isIntersecting;
          if (en.target === footer) hidden.footer = en.isIntersecting;
        });
        refresh();
      }, { threshold: 0.05 });
      if (section) io.observe(section);
      if (footer) io.observe(footer);
    }
    window.addEventListener('scroll', refresh, { passive: true });
    refresh();
  }

  /* ------------------------------------------------------------------
     Prelander: botón fijo según % leído + barra de progreso de lectura
     ------------------------------------------------------------------ */
  function initPrelander() {
    var bar = document.querySelector('[data-mtit-sticky-pre]');
    var progress = document.querySelector('[data-mtit-progress]');
    var article = document.querySelector('[data-mtit-article]');
    var product = document.getElementById('organizer');
    var footer = document.querySelector('.mtit-footer');
    if (!bar && !progress) return;
    var threshold = bar ? parseInt(bar.getAttribute('data-threshold'), 10) : 0;
    if (isNaN(threshold)) threshold = 4;
    var block = { product: false, footer: false };
    if (bar) bar.hidden = false;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === product) block.product = en.isIntersecting;
          if (en.target === footer) block.footer = en.isIntersecting;
        });
        tick();
      }, { threshold: 0.1 });
      if (product) io.observe(product);
      if (footer) io.observe(footer);
    }

    function tick() {
      var doc = document.documentElement;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      var pct = (window.scrollY / max) * 100;
      if (bar) bar.classList.toggle('is-visible', pct >= threshold && !block.product && !block.footer);
      if (progress && article) {
        var r = article.getBoundingClientRect();
        var total = Math.max(1, r.height - window.innerHeight * 0.6);
        var read = Math.min(1, Math.max(0, -r.top / total));
        progress.style.width = (read * 100).toFixed(1) + '%';
      }
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }

  function initCompare(d) {
    var mq = window.matchMedia('(max-width: 699px)');
    var apply = function () { d.open = !mq.matches; };
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mtit-compare-more]'), initCompare);
    Array.prototype.forEach.call(document.querySelectorAll('[data-mtit-buy]'), initBuy);
    Array.prototype.forEach.call(document.querySelectorAll('[data-mtit-gallery]'), initGallery);
    Array.prototype.forEach.call(document.querySelectorAll('[data-mtit-sticky]'), initSticky);
    initPrelander();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor de temas: reinicializar al recargar una sección.
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    Array.prototype.forEach.call(t.querySelectorAll('[data-mtit-buy]'), initBuy);
    Array.prototype.forEach.call(t.querySelectorAll('[data-mtit-gallery]'), initGallery);
    Array.prototype.forEach.call(t.querySelectorAll('[data-mtit-sticky]'), initSticky);
  });
})();
